/**
 * @file 特性页入口
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import Banner from '../../components/banner/Banner';
import FeatureList from './components/feature-list/FeatureList';

const Feature: React.FC = () => {
    return (
        <div className="page paddle-feature-page">
            <Header />
            <Banner
                title="特性"
                subtitle="为什么选择飞桨？"
                divider
            />
            <div className="paddle-feature-page-container">
                <div className="paddle-feature-page-context-h1">

                </div>
                <div className="paddle-feature-page-context-h3">
                    <FeatureList />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Feature;
